export const spaceAvatar = (count, type, showProfile) => {
  var spaceNumber;

  if (count) {
    if (count < 5) {
      spaceNumber = type === "table" && showProfile ? 0 : -0.5;
    }
    if (count > 4 && count < 8) {
      spaceNumber = type === "table" && showProfile ? -4 : -2;
    }
    if (count > 7) {
      spaceNumber = type === "table" && showProfile ? -4.8 : -2.5;
    }
  }

  return spaceNumber;
};
